const configMember = {
    normal: {
        listLayout: 'MemberListDefaultLayout',
        paginationLayout: 'PaginationtDefaultLayout',
        filterLayout: 'MemberFilterDefaultLayout',
        isCategory: false,
        listApiParamSet: {
            ip: 1,
        },
        getFunc: 'getFlyhighMember',
        paginationType: 'pagination',
        pageRow: 10,
    },
    normalUpdate: {
        optionLayouts: ['MemberInputLayout'],
        parsingData: {
            nick: 'mb_nick',
            memo: 'mb_memo',
            no: 'mb_no',
        },
        createApiParamSet: {
        },
        detailApiParamSet: {
            ip: 0,
        },
        resultAlertTxt: '회원정보가 수정되었습니다.',
        validateAlertText: '닉네임,비밀번호 형식을 확인하세요',
        directUrl: '',
    },
    out: {
        listLayout: 'MemberListQuitLayout',
        paginationLayout: 'PaginationtDefaultLayout',
        filterLayout: 'MemberFilterQuitLayout',
        isCategory: true,
        listApiParamSet: {
            ip: 1,
            m_type: 'out',
        },
        getFunc:'getQuitMember',
        paginationType: 'pagination',
        pageRow: 10,
    },
    cafeMember: {
        getFunc: 'getCafeMember',
        listLayout: 'MemberListDefaultLayout',
        paginationLayout: 'PaginationtDefaultLayout',
        filterLayout: 'MemberFilterDefaultLayout',
        isCategory: false,
        listApiParamSet: {
            ip: 1,
            ty: 'justreet',
        },
        paginationType: 'pagination',
        pageRow: 10,
        isCafe : true,
    },
    prohibit: {
        listLayout: 'MemberListProhibitLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getProhibit',
        listApiParamSet: {
            ip: 1,
            sp: 10,
        },
    }
}

export default {
    methods: {
        returnMemberConfig(type) {
            return configMember[type];
        }
    },
    filterConfig: {
        ni: {
            type: 'query',
            classname: 'searchInput',
        },
        mid: {
            type: 'query',
            classname: 'searchInput',
        },
        cr: {
            type: 'between',
            classname: 'filterDate',
        },
    }
}